import React, { useEffect, useState } from 'react';

import CommonService from '../../../../services/commonService';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeTwoHeader = ({ children, history, operator, onMyAccountClick, loginData, t }) => {
	const [isScrolled, setIsScrolled] = useState(false);
	const [isHomePage] = useState(window.location.pathname === '/'); // Check if it's the homepage
	const [isPrivacyPolicyPage] = useState(window.location.pathname === '/santarosa-privacy-policy');

	useEffect(() => {

		const handleScroll = () => {
			if (isHomePage && window.scrollY > 200 && operator && operator.operator_name === 'santarosa') {
				setIsScrolled(true); // Sticky effect only on the homepage and after 200px
			} else {
				setIsScrolled(false); // Reset for other pages or less scroll
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [isHomePage, operator]);

	const headerClassName =
		operator && operator.operator_name === 'biaggini' || operator && operator.operator_name === 'santarosa'
			? `biaggini-header${isScrolled ? ' scrolled-header' : ''}`
			: '';

	return operator ? (
		<div className={`${isScrolled && operator && operator.operator_name === 'santarosa' ? 'sticky-header-outer' : ''}`}>
			<div
				className={`themes-theme-two-header new-container less-bold-text ${headerClassName} ${isScrolled && operator && operator.operator_name === 'santarosa' ? 'sticky-header' : ''
					}`}
			>
				<style>
					{`
            .themes-theme-two-header {
              transition: top 0.3s ease-in-out;
            }
            .sticky-header-outer {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              z-index: 1000;
              max-width: 100% !important;
														     background: #fff;
																			box-shadow: 0 4px 2px -2px #f4f4f4;
            }
            .sticky-header {
              box-shadow: 0 4px 2px -2px #f4f4f4;
              margin-top: 0px !important;
              background: #fff;
             
            }
            .sticky-header .logo {
              width: 9vw !important;
            }
            .sticky-header .header-right-links a {
              color: #464647 !important;
            }
            .nav-section.home-nav-section.common-top-strip.header-box + * {
              margin-top: 234px;
            }
          `}
				</style>

				<div className="header-left">
					<a href="/">
						<img
							src={
								operator && operator.header_logo
									? (isScrolled && operator.operator_name === 'santarosa') || isPrivacyPolicyPage
										? '/assets/santarosa/general/logocolor.svg' // Sticky or privacy policy page logo
										: operator.header_logo
									: ''
							}
							alt="logo"
							className="logo"
							id="main-logo"
							style={{
								width: operator && operator.header_logo_width || '250px',
								margin: '10px 0',
								height: 'auto',
							}}
						/>
					</a>
				</div>

				{isHomePage && (
					<div
						className={`header-right-links ${headerClassName} ${operator.operator_name === 'buseslafit' ? 'newmenustyle' : ''
							}`}
					>
						{operator.header_links.map((val, i) => (
							<a
								className="header-right-link"
								style={{
									color:
										operator.operator_name !== 'santarosa'
											? operator.color_codes.primary_text_color
											: '#fff',
								}}
								href={Object.values(val)[0]}
								key={i}
							>
								{Object.keys(val)}
							</a>
						))}

						{window.location.pathname !== '/my-account' && operator && operator.has_user_account && (
							<ul>
								<li>
									<div className="my-account-top font10">
										<a onClick={onMyAccountClick}>
											{CommonService.isLoggedIn(loginData) && loginData && loginData.image_link ? (
												<div className="dp-image-top">
													<img src={loginData.image_link} alt="Profile" />
												</div>
											) : (
												<div className="menu-profile-icon-stripe circular-icon-stripe profile-circular-icon">
													<img
														src={getIcons('userIcon', operator)}
														alt={t('TRANSLATIONS.USER_DOT')}
													/>
												</div>
											)}
										</a>
									</div>
								</li>
							</ul>
						)}
					</div>
				)}
			</div>
		</div>
	) : null;
};

export default ThemeTwoHeader;



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTwo/common/ThemeTwoHeader.js